import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=5d3c59a8&scoped=true"
import script from "./BasicProfile.vue?vue&type=script&lang=js"
export * from "./BasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BasicProfile.vue?vue&type=style&index=0&id=5d3c59a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c59a8",
  null
  
)

export default component.exports